import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const fusionAuth = defineConnector({
  identifier: "fusionAuth",
  name: "FusionAuth",
  tagLine: "Identity and access management",
  logo,
  protocol: "http",
  tags: ["identity"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://.*.fusionauth.io/.*",
  auth: (app) =>
    headerAuth([{ name: "Authorization", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Enter your FusionAuth instance URL",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "your-instance.fusionauth.io",
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In FusionAuth, go to **Settings › API Keys** and create a new key. See the [API docs](https://fusionauth.io/docs/apis/) for details.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/status`,
  },
});
